<div id="userPreferenceSetting" class="modal fade" data-backdrop="static" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-md">
        <div class="modal-content" style="height: auto">
            <div class="modal-header content-header">
                <button class="close close-btn" aria-label="Close" data-dismiss="modal" type="button" (click)="closePopup()">
                    <ds-icon name="close" size="inherit"></ds-icon>
                </button>
                <h4 class="modal-title">
                    User Preference Setting
                    <ds-loading-spinner *ngIf="loader" theme="inherit" [diameter]="14" [strokeWidth]="2"></ds-loading-spinner>
                </h4>
            </div>
            <div class="modal-body">
                <div class="card-layout card-body pt-0 mb-3">
                    <div class="row py-2 mb-2" style="background-color: #a82b41; color: white; font-weight: 900">
                        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">User Settings</div>
                        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-0 optionClass">Options</div>
                    </div>
                    <div class="row py-2">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">Service Type</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4">
                            <div class="select-box">
                                <ng-multiselect-dropdown-angular7
                                    [settings]="dropdownSettings"
                                    [placeholder]="'Service Type'"
                                    [data]="serviceTypes"
                                    [(ngModel)]="memberPreferenceSettings.serviceType"
                                >
                                </ng-multiselect-dropdown-angular7>
                            </div>
                        </div>
                    </div>
                    <div class="row py-2">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">Status</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4">
                            <div *ngIf="statusList.length > 0" class="select-box">
                                <ng-multiselect-dropdown-angular7
                                    [settings]="statusDropdownSettings"
                                    [data]="statusList"
                                    [placeholder]="'Status'"
                                    [(ngModel)]="memberPreferenceSettings.status"
                                >
                                </ng-multiselect-dropdown-angular7>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="
                            user.role == roleName.ExecutiveAdmin ||
                            user.role == roleName.Coordinator ||
                            user.role == roleName.Accounting ||
                            user.role == roleName.Management
                        "
                        class="row py-2"
                    >
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">Customer</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4">
                            <div class="select-box">
                                <ng-multiselect-dropdown-angular7
                                    [settings]="customerListSetting"
                                    [data]="customerList"
                                    [placeholder]="'Customer'"
                                    [(ngModel)]="memberPreferenceSettings.customer"
                                >
                                </ng-multiselect-dropdown-angular7>
                            </div>
                        </div>
                    </div>
                    <div class="row py-2">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">Region</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4">
                            <div class="select-box">
                                <ng-multiselect-dropdown-angular7
                                    [settings]="regionDropdownSettings"
                                    [data]="regionList"
                                    [placeholder]="'Region'"
                                    [(ngModel)]="memberPreferenceSettings.region"
                                >
                                </ng-multiselect-dropdown-angular7>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="user.role == roleName.Accounting" class="row py-2">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">Finance Status</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4">
                            <div class="select-box">
                                <ng-multiselect-dropdown-angular7
                                    [settings]="financialStatusSetting"
                                    [data]="financialStatusList"
                                    [placeholder]="'Finance Status'"
                                    [(ngModel)]="memberPreferenceSettings.financeStatus"
                                >
                                </ng-multiselect-dropdown-angular7>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="user.role != roleName.CustomerAdmin && user.role != roleName.CustomerCoordinator" class="row py-2">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">Origin</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4">
                            <div class="select-box">
                                <ng-multiselect-dropdown-angular7
                                    placeholder="Origin"
                                    [settings]="originSetting"
                                    [data]="serviceOriginLocations"
                                    [(ngModel)]="memberPreferenceSettings.origin"
                                >
                                </ng-multiselect-dropdown-angular7>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="
                            user.role == roleName.ExecutiveAdmin ||
                            user.role == roleName.Coordinator ||
                            user.role == roleName.Accounting ||
                            user.role == roleName.Management
                        "
                        class="row py-2"
                    >
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">Vendor</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4">
                            <div *ngIf="vendorList?.length > 0" class="select-box">
                                <ng-multiselect-dropdown-angular7
                                    [settings]="vendorListSetting"
                                    [data]="vendorList"
                                    [placeholder]="'Vendor'"
                                    [(ngModel)]="memberPreferenceSettings.vendor"
                                >
                                </ng-multiselect-dropdown-angular7>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="
                            user.role == roleName.ExecutiveAdmin ||
                            user.role == roleName.Coordinator ||
                            user.role == roleName.Accounting ||
                            user.role == roleName.Management
                        "
                        class="row py-2"
                    >
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">Driver</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4">
                            <div class="select-box">
                                <ng-multiselect-dropdown-angular7
                                    [settings]="driverListSetting"
                                    [data]="driverList"
                                    [placeholder]="'Driver'"
                                    [(ngModel)]="memberPreferenceSettings.driver"
                                >
                                </ng-multiselect-dropdown-angular7>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="
                            user.role == roleName.ExecutiveAdmin ||
                            user.role == roleName.Coordinator ||
                            user.role == roleName.Accounting ||
                            user.role == roleName.Management
                        "
                        class="row py-2"
                    >
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">Assign Coordinator</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4">
                            <div class="select-box">
                                <ng-multiselect-dropdown-angular7
                                    [settings]="coordinatorFilterSetting"
                                    [data]="coordinatorData"
                                    [placeholder]="'Coordinator'"
                                    [(ngModel)]="memberPreferenceSettings.assignedCoordinator"
                                >
                                </ng-multiselect-dropdown-angular7>
                            </div>
                        </div>
                    </div>
                    <div class="row py-2">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">From Date</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4">
                            <select
                                class="form-control inline-block col-sm-3 pull-right"
                                [(ngModel)]="memberPreferenceSettings['fromDate']"
                            >
                                <option *ngFor="let filter of dateFilters" [value]="filter">{{ filter }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row py-2">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">To Date</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4">
                            <select class="form-control inline-block col-sm-3 pull-right" [(ngModel)]="memberPreferenceSettings['toDate']">
                                <option *ngFor="let filter of toDateFilters" [value]="filter">{{ filter }}</option>
                            </select>
                        </div>
                    </div>
                    <div
                        *ngIf="
                            user.role == roleName.ExecutiveAdmin ||
                            user.role == roleName.Coordinator ||
                            user.role == roleName.Accounting ||
                            user.role == roleName.Management
                        "
                        class="row py-2"
                    >
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">Job Type</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4">
                            <div *ngIf="transportTypeList && transportTypeList.length > 0" class="select-box">
                                <ng-multiselect-dropdown-angular7
                                    [settings]="transportTypeListSetting"
                                    [data]="transportTypeList"
                                    [placeholder]="'Job Type'"
                                    [(ngModel)]="memberPreferenceSettings.transportType"
                                >
                                </ng-multiselect-dropdown-angular7>
                            </div>
                        </div>
                    </div>
                    <div class="row py-2">
                        <div class="tbd-filter">
                            <label>
                                <span>Include TBD Pickup Time</span>
                                <input
                                    id="tbd-checkbox"
                                    class="mt-0 checkbox"
                                    name="tbd-checkbox"
                                    type="checkbox"
                                    [(ngModel)]="memberPreferenceSettings.includeTBD"
                                />
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="row px-3" style="display: flex; flex-direction: row-reverse">
                    <button
                        class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
                        type="button float-right"
                        (click)="saveMemberPreferenceSettings(); loader = true"
                    >
                        Save
                    </button>
                    <button
                        class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
                        data-dismiss="modal"
                        type="button float-right"
                        (click)="closePopup()"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
